import { ControlOverLegalClientStatusType } from 'api/types/entity/legal/beneficiary/controlOverEntity';
import { yesOrNotSelectValidation } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  priceAndCurrency,
  number,
  selectSchema,
} from 'libs/form';
import { PriceFieldValue } from 'libs/form/fields/PriceAndCurrencyField';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface ControlOverFormType {
  hasControlOverLegalClient?: Maybe<YesOrNoSelectType>;
  directCapitalParticipationPercentage: number;
  indirectCapitalParticipationPercentage?: number | null;
  financialConditionAmount?: Maybe<PriceFieldValue>;
  controlOverLegalClientStatus?: Maybe<
    SelectType<ControlOverLegalClientStatusType>
  >;
}

interface Args {
  enabledFinancialConditionAmount: boolean;
  enabledControlOverLegalClientStatus: boolean;
  enabledHasControlOverLegalClient: boolean;
}

export const getSchema = ({
  enabledControlOverLegalClientStatus,
  enabledFinancialConditionAmount,
  enabledHasControlOverLegalClient,
}: Args): ObjectSchema<ControlOverFormType> =>
  object({
    hasControlOverLegalClient: yesOrNotSelectValidation
      .when({
        is: () => enabledHasControlOverLegalClient,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .default(null),

    directCapitalParticipationPercentage: number().min(0).max(100).required(),
    indirectCapitalParticipationPercentage: number().min(0).max(100).nullable(),

    financialConditionAmount: priceAndCurrency()
      .when({
        is: () => enabledFinancialConditionAmount,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .default(null),

    controlOverLegalClientStatus: selectSchema(
      Object.values(ControlOverLegalClientStatusType)
    )
      .when({
        is: () => enabledControlOverLegalClientStatus,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .default(null),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<ControlOverFormType>();

export type FormErrors = FormErrorsBase<ControlOverFormType>;
